export default __webpack_public_path__ + "static/media/okta.254478ac.svg";